import React, { useEffect, useState } from "react";
import { backend, API_URL } from "../../../config";
import { Link } from "react-router-dom";
import {
  Container,
  Button,
  Modal,
  Typography,
  CircularProgress,
  Stack,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import Fees from "../components/UIs/Fees";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const ProductFees = (props) => {
  const classes = useStyles();
  const productId = props.match.params.id;

  const cDate = new Date();
  const cDateOffset = new Date(
    cDate.getTime() - cDate.getTimezoneOffset() * 60000,
  );

  const yearVal = cDateOffset.getFullYear();

  let monthVal = (1 + cDateOffset.getMonth()).toString();
  monthVal = monthVal.length > 1 ? monthVal : "0" + monthVal;

  let dayVal = cDateOffset.getDate().toString();
  dayVal = dayVal.length > 1 ? dayVal : "0" + dayVal;

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [product, setProduct] = useState({
    acceptable_substitutions: [],
    acceptable_substitutions_detail: [],
    active: true,
    case_price: 0,
    api_description: "",
    api_managed: false,
    api_manager: "",
    unit_price: 0,
    average_case_weight: 0,
    average_unit_weight: 0,
    bin: "",
    bin_normalized: "",
    catch_weight: false,
    api_department: "",
    api_department_id: 0,
    api_group: "",
    api_group_id: 0,
    item_code: {
      item_code: "",
      master_upc: null,
    },
    itemcode_set: [],
    items_per_case: 0,
    name: "",
    order_items: [],
    order_items_from_original: [],
    override: [],
    pk: null,
    price_as_of: `${monthVal}/${dayVal}/${yearVal}`,
    qb_mapping: "",
    qb_site_mapping: "",
    size: "",
    snapshots: [],
    surchargeitem_set: [],
    tax_default: false,
    unit_type: "Unit",
    units_per_case: 0,
    upc: "",
    url: null,
    use_override: false,
    volume: 0,
    volume_level: 0,
    volume_price: 0,
    warehouse: null,
    warehouse_id: null,
    weight: 0,
    weight_type: "",
    fees: [],
    margins: [],
    surcharges: [],
    unit_type_unit: false,
    unit_type_case: false,
    item_type: "",
    price_per_unit: 0,
    price_per_lb: 0,
    average_unit_price: 0,
    average_case_price: 0,
    fixed_random_weight: false,
    overridden_fields: [],
    overridden_fields_original_values: {},
    on_order: null,
    stock_level: 0,
    surcharge_upc1: null,
    surcharge_upc2: null,
  });
  const [productLoaded, setProductLoaded] = useState(false);
  const [feeInfo, setFeeInfo] = useState({
    fee_type: "margin",
    type: "",
    amount: "",
    aprice: "",
    oprice: "",
    description: "",
    company_location: "",
    product: null,
    id: null,
    hidden: false,
    warehouse: "",
    modified: false,
    deleted: false,
    new: true,
    productData: null,
  });

  const [feesMethod, setFeesMethod] = useState([]);
  const [feesType, setFeesType] = useState([]);
  const [marginTemplates, setMarginTemplates] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const [feesBase, setFeesBase] = useState(1); // 0 = product wide, 1 = per location
  const [companyLocations, setCompanyLocations] = useState([]);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);

  const handleChangeFeesBase = (base) => {
    setFeesBase(base);
  };

  const applyChangeProductFee = (
    type,
    idx,
    name,
    value,
    productData = null,
  ) => {
    const feeType = name.includes("margin") ? "margin" : "surcharge";
    const feeWarehouse = name.includes("warehouse")
      ? warehouses.find((item) => item.id === value)
      : null;
    name = name.replace(feeType + "-", "");

    if (feeType === "margin") {
      setProduct((prevState) => {
        let productFees = prevState.margins.map((fee) => {
          if (idx !== fee.id) return fee;

          let feeObj = {
            ...fee,
            [name]: value,
            warehouse: feeWarehouse === null ? fee.warehouse : feeWarehouse,
            modified: true,
          };

          if (productData !== null) {
            feeObj = {
              ...feeObj,
              oprice: ["Unit", "Unit / Case"].includes(productData.unit_type)
                ? productData.weight_type === "" ||
                  productData.weight_type === null
                  ? productData.base_unit_price
                  : productData.base_unit_price_per_lb
                : productData.weight_type === "" ||
                    productData.weight_type === null
                  ? productData.base_case_price
                  : productData.base_case_price_per_lb,
            };
          }

          let calcNumber = 0;

          if (["amount", "oprice", "type", "company_location"].includes(name)) {
            calcNumber = ["", "f"].includes(feeObj.type)
              ? feeObj.oprice + +feeObj.amount
              : feeObj.oprice * (1 + +feeObj.amount / 100);

            feeObj.aprice = calcNumber.toFixed(2);
          } else if (name === "aprice") {
            calcNumber = ["", "f"].includes(feeObj.type)
              ? +feeObj.aprice - feeObj.oprice
              : (+feeObj.aprice / feeObj.oprice) * 100 -
                (feeObj.aprice >= feeObj ? 0 : 100);

            feeObj.amount = calcNumber.toFixed(2);
          }

          return feeObj;
        });

        return { ...prevState, margins: productFees };
      });
    } else {
      setProduct((prevState) => {
        let productFees = prevState.surcharges.map((fee) => {
          if (idx !== fee.id) return fee;
          return {
            ...fee,
            [name]: value,
            warehouse: feeWarehouse === null ? fee.warehouse : feeWarehouse,
            modified: true,
          };
        });

        return { ...prevState, surcharges: productFees };
      });
    }
  };

  const handleChangeProductFee = (type, idx) => async (e) => {
    let name = null;
    let value = null;

    name = e.target.name.replace("-" + idx, "");
    value = name.includes("transparent") ? e.target.checked : e.target.value;

    console.log(name, value);

    if (name.includes("company_location")) {
      const companyLocation = companyLocations.find(
        (item) => item.id === value,
      );

      await backend
        .get(
          `${API_URL}products/${productId}/pricingformargins?company_location=${companyLocation?.company_id}`,
        )
        .then(({ data }) => {
          applyChangeProductFee(type, idx, name, value, data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      applyChangeProductFee(type, idx, name, value);
    }
  };

  const applyChangeFee = (name, value, checked, productData = null) => {
    setFeeInfo((prevState) => {
      let feeInfoObj = {
        ...prevState,
        [name]: name.includes("transparent")
          ? checked
          : name.includes("_date")
            ? value.toISOString()
            : value,
      };

      if (productData !== null) {
        feeInfoObj = {
          ...feeInfoObj,
          oprice: ["Unit", "Unit / Case"].includes(productData.unit_type)
            ? productData.weight_type === "" || productData.weight_type === null
              ? productData.base_unit_price
              : productData.base_unit_price_per_lb
            : productData.weight_type === "" || productData.weight_type === null
              ? productData.base_case_price
              : productData.base_case_price_per_lb,
          productData: productData,
        };
      }

      let calcNumber = 0;

      if (["amount", "oprice", "type", "company_location"].includes(name)) {
        calcNumber = ["", "f"].includes(feeInfoObj.type)
          ? feeInfoObj.oprice + +feeInfoObj.amount
          : feeInfoObj.oprice * (1 + +feeInfoObj.amount / 100);

        feeInfoObj.aprice = calcNumber.toFixed(2);
      } else if (name === "aprice") {
        calcNumber = ["", "f"].includes(feeInfoObj.type)
          ? +feeInfoObj.aprice - feeInfoObj.oprice
          : (+feeInfoObj.aprice / feeInfoObj.oprice) * 100 -
            (feeInfoObj.aprice >= feeInfoObj ? 0 : 100);

        feeInfoObj.amount = calcNumber.toFixed(2);
      }

      return feeInfoObj;
    });
  };

  const handleChangeFee = async (e) => {
    const { name, value, checked } = e.target;

    if (name.includes("company_location")) {
      const companyLocation = companyLocations.find(
        (item) => item.id === value,
      );

      await backend
        .get(
          `${API_URL}products/${productId}/pricingformargins?company_location=${companyLocation?.company_id}`,
        )
        .then(({ data }) => {
          applyChangeFee(name, value, checked, data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      applyChangeFee(name, value, checked);
    }
  };

  const handleClickAddFee = () => {
    const feeType = feeInfo.fee_type + "s";
    const defaultWarehouse = warehouses.filter((item) =>
      item.name.includes("Restaurant Depot"),
    );

    delete feeInfo.fee_type;

    const feeInfoObj = {
      ...feeInfo,
      product: productId,
      warehouseId: feeInfo.warehouse === null ? "" : feeInfo.warehouse.id,
    };

    setProduct((prevState) => ({
      ...prevState,
      [feeType]: [...prevState[feeType], feeInfoObj],
    }));

    setFeeInfo({
      fee_type: "",
      type: "",
      amount: "",
      aprice: "",
      oprice: "",
      description: "",
      company_location: "",
      product: productId,
      id: null,
      hidden: false,
      warehouse: defaultWarehouse.length ? defaultWarehouse[0] : "",
      deleted: false,
      modified: false,
      new: true,
      productData: null,
    });
  };

  const handleClickDeleteFee = (deletedFee) => {
    const [type, feeIndex] = deletedFee.split("-");

    if (type === "margin") {
      setProduct((prevState) => {
        const marginsNew = prevState.margins.map((item) => {
          if (item.id !== +feeIndex) return item;
          return { ...item, deleted: true };
        });

        return { ...prevState, margins: marginsNew };
      });
    } else {
      setProduct((prevState) => {
        const surchargesNew = prevState.surcharges.map((item) => {
          if (item.id !== +feeIndex) return item;
          return { ...item, deleted: true };
        });

        return { ...prevState, surcharges: surchargesNew };
      });
    }
  };

  const handleBack = () => {
    props.history.push("/inventory");
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to {!isNaN(productId) ? " update " : " add "}
          the product <b>{product.api_description || product.name}</b>
          <br />
          <br />
          {feeInfo.amount !== "" &&
          (feeInfo.type === "" || feeInfo.warehouse === "") ? (
            <div style={{ color: "red" }}>
              <b>Note: </b>You have a fee amount configured but can't be saved,
              please complete the form.
              <br />
              <br />
            </div>
          ) : (
            <></>
          )}
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {!isNaN(productId) ? " Updating product " : " Adding product "}
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while
              {!isNaN(productId) ? " updating " : " saving "}the product
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {typeof errorInfo.message === "object" ? (
                  <>
                    <ul>
                      {Object.keys(errorInfo.message).map((key) => (
                        <li key={key}>
                          <b>{key}:</b>
                          {` ${errorInfo.message[key]}`}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  errorInfo.message
                )}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The product has been{!isNaN(productId) ? " updated " : " added "}
          successfully
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleDeleteConfirmModal = () =>
    setDeleteConfirmModal(!deleteConfirmModal);

  const deleteConfirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to delete the product
          <b> {product.api_description || product.name}</b>
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleDeleteConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendDeleteRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>Deleting product</div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while deleting the product
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {typeof errorInfo.message === "object" ? (
                  <>
                    <ul>
                      {Object.keys(errorInfo.message).map((key) => (
                        <li key={key}>
                          <b>{key}:</b>
                          {` ${errorInfo.message[key]}`}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  errorInfo.message
                )}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The product has been deleted successfully
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const sendRequest = () => {
    setLoadingFlag(true);

    const marginsDeleted = product.margins.filter((item) => item.deleted);
    const marginsModified = product.margins.filter(
      (item) => item.modified && !item.new && !item.deleted,
    );
    let marginsNew = product.margins.filter(
      (item) => item.id === null && item.new && !item.deleted,
    );

    if (
      feeInfo.amount !== "" &&
      feeInfo.type !== "" &&
      feeInfo.warehouse !== ""
    ) {
      const defaultWarehouse = warehouses.filter((item) =>
        item.name.includes("Restaurant Depot"),
      );

      delete feeInfo.fee_type;
      delete feeInfo.productData;

      const feeInfoObj = {
        ...feeInfo,
        product: productId,
        warehouseId: feeInfo.warehouse === null ? "" : feeInfo.warehouse.id,
      };

      marginsNew = [...marginsNew, feeInfoObj];

      setFeeInfo({
        fee_type: "",
        type: "",
        amount: "",
        aprice: "",
        oprice: "",
        description: "",
        company_location: "",
        product: productId,
        id: null,
        hidden: false,
        warehouse: defaultWarehouse.length ? defaultWarehouse[0] : "",
        deleted: false,
        modified: false,
        new: true,
        productData: null,
      });
    }

    if (marginsDeleted.length) {
      marginsDeleted.forEach(async (item) => {
        await backend
          .delete(`${API_URL}margintemplates/${item.id}`)
          .then()
          .catch((error) => {
            console.log(error);
            const errorData = error.response.data;

            setErrorInfo({
              error: true,
              message:
                typeof errorData === "object"
                  ? errorData.hasOwnProperty("message")
                    ? errorData.message
                    : errorData.detail
                  : error.message,
            });
          });
      });
    }

    if (marginsModified.length) {
      marginsModified.forEach(async (item) => {
        delete item.deleted;
        delete item.modified;
        delete item.new;

        const marginObj = { ...item };
        delete marginObj.warehouseId;
        delete marginObj.warehouse;

        await backend
          .patch(`${API_URL}margintemplates/${marginObj.id}`, marginObj)
          .then()
          .catch((error) => {
            console.log(error);
            const errorData = error.response.data;

            setErrorInfo({
              error: true,
              message:
                typeof errorData === "object"
                  ? errorData.hasOwnProperty("message")
                    ? errorData.message
                    : errorData.detail
                  : error.message,
            });
          });
      });
    }

    if (marginsNew.length) {
      marginsNew.forEach(async (item) => {
        delete item.new;
        delete item.modified;

        const marginObj = { ...item };
        delete marginObj.warehouseId;
        delete marginObj.warehouse;

        await backend
          .post(`${API_URL}margintemplates/`, marginObj)
          .then()
          .catch((error) => {
            console.log(error);
            const errorData = error.response.data;

            setErrorInfo({
              error: true,
              message:
                typeof errorData === "object"
                  ? errorData.hasOwnProperty("message")
                    ? errorData.message
                    : errorData.detail
                  : error.message,
            });
          });
      });
    }

    if (!errorInfo.error) {
      setLoadingFlag(false);
      setFinishedFlag(true);
    }
  };

  const sendDeleteRequest = async () => {
    setLoadingFlag(true);

    await backend
      .delete(`${API_URL}products/${productId}`)
      .then(() => {
        setLoadingFlag(false);
        setFinishedFlag(true);
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.hasOwnProperty("message")
                  ? errorData.detail
                  : errorData
              : error.message,
        });
      });
  };

  const resolveError = () => {
    toggleConfirmModal();
    setLoadingFlag(false);
    setFinishedFlag(false);
    setErrorInfo({ error: false, message: "" });
  };

  const resolveRequest = () => {
    props.history.push("/inventory");
  };

  useEffect(() => {
    const getFeesMethod = () => {
      setFeesMethod(["f", "%"]);
    };

    const getFeesType = () => {
      // setFeesType(["margin", "surcharge"]);
      setFeesType(["margin"]);
    };

    const getMarginTemplates = async () => {
      await backend
        .get(`${API_URL}margintemplates?no_page=1`)
        .then(({ data }) => {
          const dataMap = data.map((item) => ({
            ...item,
            modified: false,
            new: false,
          }));
          setMarginTemplates(dataMap); // todo: remove dataMap and leave data
        });
    };

    const getWarehouses = async () => {
      await backend.get(`${API_URL}warehouses?no_page=1`).then(({ data }) => {
        const dataMap = data.map((item) => ({ id: item.id, name: item.name }));
        setWarehouses(dataMap);
        const defaultWarehouse = dataMap.filter((item) =>
          item.name.includes("Restaurant Depot"),
        );
        setFeeInfo((prevState) => ({
          ...prevState,
          warehouse: defaultWarehouse.length ? defaultWarehouse[0] : null,
        }));
      });
    };

    const getCompanyLocations = async () => {
      await backend
        .get(`${API_URL}companylocations?no_page=1`)
        .then(({ data }) => {
          const dataMap = data.map((item) => ({
            id: item.id,
            name: item.name,
            company_id: item.company_id,
          }));

          setCompanyLocations(dataMap);
        });
    };

    getFeesMethod();
    getFeesType();
    getMarginTemplates();
    getWarehouses();
    getCompanyLocations();
  }, []);

  useEffect(() => {
    const getProduct = async () => {
      await backend
        .get(`${API_URL}productedit/${productId}?substitution_detail=true`)
        .then(async ({ data }) => {
          const defaultOPrice = ["Unit", "Unit / Case"].includes(data.unit_type)
            ? data.unit_price
            : data.case_price;

          const productMarginTemplates = marginTemplates.filter(
            (item) => item.product === +productId,
          );

          let productMarginTemplatesMap = [];

          await Promise.all(
            productMarginTemplates.map(async (item) => {
              if (item.company_location) {
                const companyLocation = companyLocations.find(
                  (cl) => cl.id === item.company_location,
                );

                return await backend
                  .get(
                    `${API_URL}products/${productId}/pricingformargins?company_location=${companyLocation?.company_id}`,
                  )
                  .then(({ data }) => {
                    console.log(data);
                    return Promise.resolve({ ...item, productData: data });
                  })
                  .catch((error) => {
                    console.log(error);
                    return Promise.reject(error);
                  });
              } else {
                return Promise.resolve({ ...item, productData: null });
              }
            }),
          )
            .then((results) => {
              const productMarginsMap = results.map((item) => {
                let aprice = 0;

                const basePrice =
                  (["Unit", "Unit / Case"].includes(data.unit_type)
                    ? item.productData?.weight_type === "" ||
                      item.productData?.weight_type === null
                      ? item.productData?.base_unit_price
                      : item.productData?.base_unit_price_per_lb
                    : item.productData?.weight_type === "" ||
                        item.productData?.weight_type === null
                      ? item.productData?.base_case_price
                      : item.productData?.base_case_price_per_lb) ||
                  defaultOPrice;

                if (item.type === "f") {
                  aprice = +basePrice + +item.amount;
                } else {
                  aprice = +basePrice * (1 + +item.amount / 100);
                }

                return {
                  ...item,
                  aprice: aprice.toFixed(2),
                  oprice: basePrice,
                  hidden: feesBase
                    ? item.company_location === ""
                    : item.product === null,
                  company_location:
                    item.company_location === null ? "" : item.company_location,
                };
              });

              productMarginTemplatesMap = productMarginsMap;

              return Promise.resolve(productMarginsMap);
            })
            .catch((error) => {
              console.log(error);
            });

          const calcAverageUnitPrice =
            data.unit_price * data.average_unit_weight;
          const calcAverageCasePrice =
            data.case_price * data.average_case_weight;

          const productObj = {
            ...data,
            fees: data.fees || [],
            margins: productMarginTemplatesMap,
            surcharges: [],
            unit_type_unit:
              data.unit_type === "Unit" || data.unit_type === "Unit / Case"
                ? true
                : false,
            unit_type_case:
              data.unit_type === "Case" || data.unit_type === "Unit / Case"
                ? true
                : false,
            item_type:
              data.weight_type === "r/w"
                ? "catch_weight"
                : data.weight_type === "fix"
                  ? "fixed_random_weight"
                  : "",
            price_per_unit:
              data.case_price && data.units_per_case
                ? (data.case_price / data.units_per_case).toFixed(2)
                : 0,
            unit_price: data.unit_price || 0,
            case_price: data.case_price || 0,
            volume_level: data.volume_level || 0,
            volume_price: data.volume_price || 0,
            average_unit_price: calcAverageUnitPrice,
            average_case_price: calcAverageCasePrice,
            catch_weight: data.catch_weight || false,
            fixed_random_weight: data.fixed_random_weight || false,
          };

          setFeeInfo((prevState) => ({
            ...prevState,
            oprice: defaultOPrice,
            productData: productObj,
          }));
          setProduct(productObj);
          setProductLoaded(true);
        });
    };

    if (
      !isNaN(productId) &&
      marginTemplates.length &&
      companyLocations.length &&
      !productLoaded
    ) {
      getProduct();
    }
  }, [feesBase, marginTemplates, productId, productLoaded, companyLocations]);

  useEffect(() => {
    const filterCustomerFees = () => {
      setProduct((prevState) => {
        const marginsFiltered = prevState.margins.map((item) => ({
          ...item,
          hidden: feesBase
            ? item.company_location === ""
            : item.product === null,
        }));

        const surchargesFiltered = prevState.surcharges.map((item) => ({
          ...item,
          hidden: feesBase
            ? item.company_location === ""
            : item.product === null,
        }));

        return {
          ...prevState,
          margins: marginsFiltered,
          surcharges: surchargesFiltered,
        };
      });
    };

    filterCustomerFees();
  }, [feesBase]);

  return (
    <>
      <Container>
        <Modal open={confirmModal} onClose={toggleConfirmModal}>
          {confirmModalContent}
        </Modal>
        <Modal open={deleteConfirmModal} onClose={toggleDeleteConfirmModal}>
          {deleteConfirmModalContent}
        </Modal>
        <Stack direction="row" spacing={1} justifyContent="center">
          <Link to={`/product/${productId}`}>
            <Button variant="contained" color="inherit">
              <Typography variant="subtitle2" color="black">
                Product
              </Typography>
            </Button>
          </Link>
          <Button variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              Fees
            </Typography>
          </Button>
        </Stack>
        <br />
        <Typography component="h6" variant="h6" align="center">
          {`${productId ? "Edit" : "Add"} ${product.name || ""} Fees`}
        </Typography>
        <Fees
          {...props}
          feeInfo={feeInfo}
          feesMethod={feesMethod}
          feesType={feesType}
          product={product}
          feesBase={feesBase}
          companyLocations={companyLocations}
          handleChangeProductFee={handleChangeProductFee}
          handleChangeFee={handleChangeFee}
          handleClickAddFee={handleClickAddFee}
          handleClickDeleteFee={handleClickDeleteFee}
          handleChangeFeesBase={handleChangeFeesBase}
        />
        <br />
        <Stack direction="row" spacing={1} justifyContent="right">
          <Button onClick={handleBack}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => toggleConfirmModal()}
          >
            Save
          </Button>
        </Stack>
      </Container>
    </>
  );
};

export default ProductFees;
